var _rect, _rect2, _path, _rect3, _path2, _rect4, _path3, _rect5, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 476,
    viewBox: "0 0 476 476",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 228,
    rx: 30,
    transform: "matrix(-1 0 0 1 228 0)",
    fill: "#F2CD88"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 114,
    rx: 30,
    transform: "matrix(-1 0 0 1 228 0)",
    fill: "#F2EFE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 228C61.3009 228 16.9536 192.242 3.89792 143.665C-0.402495 127.664 13.4315 114 30 114L198 114C214.569 114 228.402 127.664 224.102 143.665C211.046 192.242 166.699 228 114 228Z",
    fill: "#B89FBF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 228,
    width: 228,
    height: 228,
    rx: 30,
    transform: "rotate(180 476 228)",
    fill: "#B89FBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362 114C309.301 114 264.954 149.758 251.898 198.335C247.598 214.336 261.431 228 278 228H446C462.569 228 476.402 214.336 472.102 198.335C459.046 149.758 414.699 114 362 114Z",
    fill: "#F2EFE9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 228,
    rx: 30,
    transform: "matrix(-1 0 0 1 228 248)",
    fill: "#F2EFE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 476C13.4314 476 -0.202972 462.512 1.97085 446.086C4.57266 426.427 9.73389 407.148 17.3554 388.748C28.8135 361.086 45.6079 335.951 66.7796 314.78C87.9514 293.608 113.086 276.814 140.748 265.355C159.148 257.734 178.427 252.573 198.086 249.971C214.512 247.797 228 261.431 228 278L228 446C228 462.569 214.569 476 198 476H30Z",
    fill: "#B89FBF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 476,
    width: 228,
    height: 228,
    rx: 30,
    transform: "rotate(180 476 476)",
    fill: "#F2CD88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M446 476C462.569 476 476.203 462.512 474.029 446.086C471.427 426.427 466.266 407.148 458.645 388.748C447.186 361.086 430.392 335.951 409.22 314.78C388.049 293.608 362.914 276.814 335.252 265.355C316.852 257.734 297.573 252.573 277.914 249.971C261.488 247.797 248 261.431 248 278L248 446C248 462.569 261.431 476 278 476H446Z",
    fill: "#F7EDD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.4f1fd9eec4b6cf32e5bc8db4cf29c3f7.svg";
export { ForwardRef as ReactComponent };